import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    shellId: { type: String, default: "add-step-modal" },
  }

  open(event) {
    const shell = document.getElementById(this.shellIdValue)
    if (!shell) return

    const modal = shell.querySelector("dialog")
    if (modal && typeof modal.showModal === "function") {
      modal.showModal()
    }
  }
}
